import { Link } from '@vp/swan'

type LinkWrapperProps = React.ComponentProps<typeof Link>

export function LinkWrapper({ href, children, ...props }: LinkWrapperProps) {
  return href ? (
    <Link href={href} {...props}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  )
}
